const socials = [
  {
    name: "Twitter / X",
    handle: "@solidhardwarenet",
    icon: "ri-twitter-x-line",
    desc: "Follow for real-time updates, tech news, and launch announcements.",
    href: "https://twitter.com/solidhardwarenet",
    color: "from-gray-700/40 to-gray-800/40",
    accent: "#e2e8f0",
  },
  {
    name: "LinkedIn",
    handle: "SolidHardware",
    icon: "ri-linkedin-box-line",
    desc: "Connect with us professionally and stay in the loop on company news.",
    href: "https://linkedin.com/company/solidhardware",
    color: "from-sky-900/30 to-sky-950/30",
    accent: "#7dd3fc",
  },
  {
    name: "GitHub",
    handle: "solidhardware",
    icon: "ri-github-line",
    desc: "Explore open-source tools, drivers, and community projects.",
    href: "https://github.com/solidhardware",
    color: "from-gray-700/40 to-gray-800/40",
    accent: "#d1d5db",
  },
  {
    name: "Discord",
    handle: "SolidHardware Community",
    icon: "ri-discord-line",
    desc: "Join our community of builders, engineers, and hardware enthusiasts.",
    href: "https://discord.gg/solidhardware",
    color: "from-indigo-900/30 to-indigo-950/30",
    accent: "#a5b4fc",
  },
  {
    name: "YouTube",
    handle: "SolidHardware",
    icon: "ri-youtube-line",
    desc: "Watch reviews, teardowns, and tutorials from our expert team.",
    href: "https://youtube.com/@solidhardware",
    color: "from-red-900/20 to-red-950/20",
    accent: "#fca5a5",
  },
  {
    name: "Instagram",
    handle: "@solidhardwarenet",
    icon: "ri-instagram-line",
    desc: "Behind-the-scenes content, product shots, and community highlights.",
    href: "https://instagram.com/solidhardwarenet",
    color: "from-pink-900/20 to-rose-950/20",
    accent: "#f9a8d4",
  },
];

export default function SocialSection() {
  return (
    <section id="social" className="relative py-28 px-4" style={{ background: "linear-gradient(180deg, #080c14 0%, #0a0a0f 100%)" }}>
      <div className="max-w-6xl mx-auto">
        {/* Label */}
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="h-px w-12 bg-cyan-500/40" />
          <span className="text-cyan-400 text-xs font-mono tracking-widest uppercase">// Connect</span>
          <div className="h-px w-12 bg-cyan-500/40" />
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-white text-center leading-tight mb-4">
          Follow Our <span className="text-cyan-400">Journey</span>
        </h2>
        <p className="text-gray-400 text-center max-w-xl mx-auto text-base md:text-lg leading-relaxed mb-14">
          We&apos;re active across platforms. Join the conversation and be part of the SolidHardware community before we even launch.
        </p>

        {/* Social grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {socials.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group relative rounded-xl p-6 border border-white/5 hover:border-white/15 transition-all duration-300 cursor-pointer"
              style={{ background: `linear-gradient(135deg, ${s.color.split(" ")[0].replace("from-", "").replace("/", " / ")}, ${s.color.split(" ")[1].replace("to-", "").replace("/", " / ")})` }}
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg border border-white/10 shrink-0 group-hover:scale-110 transition-transform duration-300" style={{ background: "rgba(255,255,255,0.06)" }}>
                  <i className={`${s.icon} text-xl`} style={{ color: s.accent }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <span className="text-white font-bold text-sm">{s.name}</span>
                    <i className="ri-arrow-right-up-line text-gray-600 group-hover:text-white transition-colors duration-300 text-sm shrink-0" />
                  </div>
                  <p className="text-xs font-mono mb-2" style={{ color: s.accent }}>{s.handle}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
